import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

import background from './assets/background.png?file';

export default makeStyles({ name: 'AiInsights' })((theme) => ({
    container: {
        position: 'relative',
        zIndex: 0,
        padding: '24px 24px 32px 24px',
        marginTop: 24,
        borderRadius: 16,
        border: '1px solid #ECECEC',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 16,
            padding: 16
        }
    },
    hatch: {
        userSelect: 'none',
        zIndex: -1,
        content: '""',
        position: 'absolute',
        width: 480,
        height: 120,
        bottom: 0,
        right: 0,
        borderRadius: 16,
        background: `url(${background}) center / cover no-repeat`
    },
    item: {
        minHeight: 64
    }
}));
